import React, { useEffect } from "react";
import "./about.css";
import Navbar from "../../components/Navbar/Navbar";
import Blacknavtop from "../../components/Navbar/Blacknavtop";
import Footer from "../../components/footer/main";
import Fade from "@material-ui/core/Fade";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { Container } from "@material-ui/core";

const About = () => {
  return (
    <div className="bg_smoke">
      <Blacknavtop />
      <Navbar />
      <br />
      <div className="container mt_10rem mb_6rem">
        <div className="row">
          <div className="col-lg-6 col-md-6 mb_4rem ">
            <div className="border_left_blue pl_15">
              <h6 className="tblue">WHO WE ARE?</h6>
              <h1>We are a team of professional Charatered Accountants.</h1>
            </div>
          </div>
          <div className="col-lg-6 col-md-6">
            <img src={require("../../Assets/team_presentation_.svg")} width="80%" />
          </div>
          <div className="col-lg-6 col-md-6 desktop_view">
            <img src={require("../../Assets/motivation.svg")} width="80%" />
          </div>
          <div className="col-lg-6 col-md-6 mt_4rem mb_4rem ">
            <div className="border_right_blue">
              <h3 className="fontfam fbold ">
                Our mission is to provide the best financial services and investment decisions.
              </h3>
              <p>
                Earning from 9-5 can make you <b className="tblue">millionaire</b> but proper
                knowledge of finance can make you <b className="tblue">billionaire</b> without any
                effort
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 mobile_view">
            <img src={require("../../Assets/motivation.svg")} width="80%" />
          </div>
        </div>

        <div className="mt_4rem mb_4rem count_div">
          <Container>
            <div className="row">
              <div className="col-lg-6 col-md-6 col-xs-12 tcenter">
                <h1 className="fbold">
                  5,000 <span className="tblue">+</span>
                </h1>
                <h3 className="tgrey">
                  <b>CLIENTS</b>
                </h3>
              </div>
              <div className="col-lg-6 col-md-6 col-xs-12 tcenter">
                <h1 className="fbold">
                  80,00,000 INR <span className="tblue">+</span>
                </h1>
                <h3 className="tgrey">
                  <b>SAVED FOR CLIENTS</b>
                </h3>
              </div>
            </div>
          </Container>
        </div>

        <div className="mt_4rem">
          <br />
          <div className="tcenter mt_4rem">
            <h1>HAVE ANY QUERY?</h1>
            <p className="fs12 tgrey">Reach out to us at</p>
            <div className="row mt_4rem">
              <div className="col-lg-6 col-md-6 col-xs-12 tcenter">
                <img src={require("../../Assets/email.svg")} width="70px" />
                <h3>Email us at:</h3>
                <p className="fbold fs12 tblue">Rupanshkapoor@gmail.com</p>
              </div>
              <div className="col-lg-6 col-md-6 col-xs-12 tcenter">
                <img src={require("../../Assets/whatsapp.svg")} width="70px" />
                <h3>Whatsapp us at:</h3>
                <p className="fbold fs12 tblue">8851956910</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default About;
